import { render, staticRenderFns } from "./work-stats.vue?vue&type=template&id=5699099f&scoped=true"
import script from "./work-stats.vue?vue&type=script&lang=js"
export * from "./work-stats.vue?vue&type=script&lang=js"
import style0 from "./work-stats.vue?vue&type=style&index=0&id=5699099f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5699099f",
  null
  
)

export default component.exports